import { Component, computed, OnInit, signal } from '@angular/core';

interface Atividade {
  nome: string;
  inicio: number; // 1 a 12
  firstMonth?: string; // Opcional, para atividades pontuais
  lastMonth?: string;  // Opcional, para atividades pontuais
  fim: number;    // 1 a 12
  cor: string;
  categoria: string;
}
@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
  standalone: false
})


export class ScheduleComponent implements OnInit {
// Controla se a agenda está expandida (true) ou no modo "Mês Atual" (false)
  isExpanded = signal<boolean>(false);

  // Define o mês atual (Março = 3)
  mesAtual = signal<number>(new Date().getMonth() + 1);

  meses = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  rawAtividades: Atividade[] = [
    //Performace
    { nome: "Fim Aval. Performance", firstMonth: 'Janeiro', lastMonth: 'Janeiro', inicio: 1, fim: 1, cor: 'purple', categoria: 'Performance' },
    { nome: "Colegiado", firstMonth: 'Janeiro', lastMonth: 'Março', inicio: 1, fim: 3, cor: 'purple', categoria: 'Performance' },
    { nome: "Feedbacks", firstMonth: 'Abril', lastMonth: 'Maio', inicio: 4, fim: 5, cor: 'purple', categoria: 'Performance' },
    { nome: "PDI Corporativo", firstMonth: 'Abril', lastMonth: 'Maio', inicio: 4, fim: 5, cor: 'purple', categoria: 'Performance' },
    { nome: "Checkpoint Performance", firstMonth: 'Agosto', lastMonth: 'Setemrbro', inicio: 8, fim: 9, cor: 'purple', categoria: 'Performance' },
    { nome: "Indicação Pares e Cli.Internos Performance", firstMonth: 'Novembro', lastMonth: 'Novembro', inicio: 11, fim: 11, cor: 'purple', categoria: 'Performance' },
    { nome: "Aval.Performance", firstMonth: 'Dezembro', lastMonth: 'Dezembro', inicio: 12, fim: 12, cor: 'purple', categoria: 'Performance' },
    //Matriz de Competências
    { nome: "Config. Matriz", firstMonth: 'Março', lastMonth: 'Março', inicio: 3, fim: 3, cor: 'pink', categoria: 'Matriz' },
    { nome: "Auto Avaliação",firstMonth: 'Março', lastMonth: 'Março', inicio: 3, fim: 3, cor: 'pink', categoria: 'Matriz' },
    { nome: "Avaliação 180°",firstMonth: 'Março', lastMonth: 'Março', inicio: 3, fim: 3, cor: 'pink', categoria: 'Matriz' },
    { nome: "Análise de GAPS",firstMonth: 'Março', lastMonth: 'Março', inicio: 3, fim: 3, cor: 'pink', categoria: 'Matriz' },
    { nome: "Alinhamento com Liderado",firstMonth: 'Março', lastMonth: 'Março', inicio: 3, fim: 3, cor: 'pink', categoria: 'Matriz' },
    { nome: "Plano de Ação Matriz",firstMonth: 'Março', lastMonth: 'Março', inicio: 3, fim: 3, cor: 'pink', categoria: 'Matriz' },
    { nome: "Execução Plano de Ação Matriz", firstMonth: 'Abril', lastMonth: 'Junho',inicio: 4, fim: 6, cor: 'pink', categoria: 'Matriz' },
    { nome: "Config. Matriz", firstMonth: 'Julho', lastMonth: 'Julho',inicio: 7, fim: 7, cor: 'pink', categoria: 'Matriz' },
    { nome: "Auto Avaliação", firstMonth: 'Julho', lastMonth: 'Julho',inicio: 7, fim: 7, cor: 'pink', categoria: 'Matriz' },
    { nome: "Avaliação 180°", firstMonth: 'Julho', lastMonth: 'Julho',inicio: 7, fim: 7, cor: 'pink', categoria: 'Matriz' },
    { nome: "Análise de GAPS", firstMonth: 'Julho', lastMonth: 'Julho',inicio: 7, fim: 7, cor: 'pink', categoria: 'Matriz' },
    { nome: "Alinhamento com Liderado",firstMonth: 'Julho', lastMonth: 'Julho', inicio: 7, fim: 7, cor: 'pink', categoria: 'Matriz' },
    { nome: "Plano de Ação Matriz", firstMonth: 'Julho', lastMonth: 'Julho', inicio: 7, fim: 7, cor: 'pink', categoria: 'Matriz' },
    //Agile Game
    { nome: "Execução Plano de Ação Matriz",firstMonth: 'Agosto', lastMonth: 'Dezembro', inicio: 8, fim: 12, cor: 'pink', categoria: 'Matriz' },
    { nome: "Levant. e validações metas",firstMonth: 'Janeiro', lastMonth: 'Janeiro', inicio: 1, fim: 1, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Fim Apuração Individual",firstMonth: 'Janeiro', lastMonth: 'Janeiro', inicio: 1, fim: 1, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Validações metas próximo semestre",firstMonth: 'Junho', lastMonth: 'Junho', inicio: 6, fim: 6, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Levant. e validações Metas",firstMonth: 'Junho', lastMonth: 'Junho', inicio: 6, fim: 6, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Levant. e validações Metas para cadastro",firstMonth: 'Julho', lastMonth: 'Julho', inicio: 7, fim: 7, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Início Apuração Individual",firstMonth: 'Julho', lastMonth: 'Julho', inicio: 7, fim: 7, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Fim Apuração Individual",firstMonth: 'Agosto', lastMonth: 'Agosto', inicio: 8, fim: 8, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Validações Metas próximo semestre",firstMonth: 'Novembro', lastMonth: 'Novembro', inicio: 11, fim: 11, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "SOS para orientações das Avaliações",firstMonth: 'JaneNovemrbroiro', lastMonth: 'Novemrbro', inicio: 11, fim: 11, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Início Apuração Individual",firstMonth: 'Dezembro', lastMonth: 'Dezembro', inicio: 12, fim: 12, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Atualização das Metas Avulsas (até o 5° dia)",firstMonth: 'Janeiro', lastMonth: 'Dezembro', inicio: 1, fim: 12, cor: 'dark-blue', categoria: 'Metas' },
    { nome: "Status Report Agile Game", firstMonth: 'Janeiro', lastMonth: 'Dezembro', inicio: 1, fim: 12, cor: 'dark-blue', categoria: 'Metas' }
  ];

  // // COMPUTED: Filtra o que está acontecendo no mês atual para a visão compacta
  agendaHoje = computed(() => {
    const mes = this.mesAtual();
    return this.rawAtividades.filter(a => mes >= a.inicio && mes <= a.fim);
  });

  // Adicione ou modifique o computed agendaHoje para remover itens recorrentes do grid
    // agendaHoje = computed(() => {
    //   const mes = this.mesAtual();
    //   // Filtramos itens que duram o ano todo (1 a 12) para não poluir os cards
    //   return this.rawAtividades.filter(a => 
    //     mes >= a.inicio && 
    //     mes <= a.fim && 
    //     !(a.inicio === 1 && a.fim === 12) 
    //   );
    // });

  // COMPUTED: Organiza os dados para a timeline vertical (Exibe a tarefa em cada mês do intervalo)
  cronogramaVertical = computed(() => {
    return this.meses.map((nomeMes, index) => {
      const numeroMes = index + 1;
      
      const tarefasDoMes = this.rawAtividades.filter(a => 
        numeroMes >= a.inicio && numeroMes <= a.fim
      ).map(t => ({
        ...t,
        statusNoMes: this.calcularStatus(t, numeroMes)
      }));

      return { nomeMes, numeroMes, tarefasDoMes };
    });
  });

  ngOnInit(): void {
    // Lógica opcional de inicialização
  }

  toggleView(): void {
    this.isExpanded.set(!this.isExpanded());
  }

  private calcularStatus(t: Atividade, mes: number): string {
    if (t.inicio === t.fim) return 'pontual';
    if (mes === t.inicio) return 'inicio';
    if (mes === t.fim) return 'fim';
    return 'meio';
  }

  get atividadesAgrupadas() {
  const grupos: any[] = [];

  this.rawAtividades.forEach(ativ => {
    // Busca se já existe um grupo para essa categoria no mesmo período
    const grupoExistente = grupos.find(g => 
      g.categoria === ativ.categoria && 
      g.inicio === ativ.inicio && 
      g.fim === ativ.fim
    );

    if (grupoExistente) {
      grupoExistente.itens.push(ativ.nome);
    } else {
      grupos.push({
        categoria: ativ.categoria,
        inicio: ativ.inicio,
        fim: ativ.fim,
        cor: ativ.cor,
        itens: [ativ.nome]
      });
    }
  });
  return grupos;
}
}
